<template>
    <div class="md:container flex">
        <portal to="header">
            <GroupShowHeader />
        </portal>

        <portal to="breadcrumbs">
            <div class="container">
                <Breadcrumbs
                    :breadcrumbs="breadcrumbs"
                    class="mb-3 pt-3 md:pt-7"
                />
            </div>
        </portal>

        <TabsPanel
            model-value="discussion"
            panel-list-class="mb-4 md:mb-6"
            class="min-w-0"
        >
            <TabsPanelTab
                id="discussion"
                :name="t('discussion')"
                :component="tabs.GroupShowDiscussion"
            ></TabsPanelTab>
            <TabsPanelTab
                v-if="group.faqEnabled"
                id="faq"
                :name="faqTabName"
                :progress="faqProgress"
                :component="tabs.GroupShowFaq"
            ></TabsPanelTab>
        </TabsPanel>
        <TheRightSidebar
            v-if="isLoggedIn"
            top-spacing
        />
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import TabsPanel from '@components/TabsPanel';
import TabsPanelTab from '@components/TabsPanelTab';
import TabsPanelSpinner from '@components/TabsPanelTab/TabsPanelSpinner.vue';
import Breadcrumbs from '@components/Breadcrumbs';
import TheRightSidebar from '@components/TheRightSidebar';
import { mapGetters } from 'vuex';
import { trackImpression } from '@/modules/tracking';
import JobSeekerMixin from '@/mixins/jobSeekerMixin';
import route from '@router/route';
import { useTranslation } from 'i18next-vue';
import GroupShowHeader from './GroupShowHeader.vue';

const load = (loader) =>
    defineAsyncComponent({
        loader,
        loadingComponent: TabsPanelSpinner,
    });

export default {
    name: 'GroupShow',
    components: {
        GroupShowHeader,
        TabsPanel,
        TabsPanelTab,
        Breadcrumbs,
        TheRightSidebar,
    },
    extends: JobSeekerMixin,
    setup() {
        const { t } = useTranslation('group');
        return { t };
    },
    data() {
        return {
            group: window.sdWindow.group,
            breadcrumbs: [],
        };
    },
    computed: {
        ...mapGetters({
            isLoggedIn: 'auth/isLoggedIn',
            screenSize: 'ui/screenSize',
            userGroups: 'user/groups',
            faq: 'group/faq',
            faqTabName: 'group/faqTitle',
            faqProgress: 'group/faqProgress',
        }),
        tabs() {
            return {
                GroupShowFaq: load(() => import('./GroupShowFaq.vue')),
                GroupShowDiscussion: load(() => import('./GroupShowDiscussion.vue')),
            };
        },
    },

    created() {
        this.setBreadcrumbs();
    },

    mounted() {
        this.$store.dispatch('group/setGroupData', this.group);
        if (this.group.faqEnabled) {
            this.retrieveFaq();
        }

        trackImpression('GroupPage', {
            group_id: this.group.id,
        });

        this.setJobSeekerStatus();
    },
    methods: {
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    title: this.group.name,
                    link: route('groups.show', {
                        groupName: this.group.slug,
                        id: this.group.id,
                    }),
                },
            ];
        },
        retrieveFaq() {
            this.$store.dispatch('group/retrieveFaq', this.group);
        },
        setJobSeekerStatus() {
            if (this.group.isCareerGroup === true) {
                this.storeJobSeekerStatus();
            }
        },
    },
};
</script>
